<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="3">
          <v-avatar
            color="primary"
            rounded="0"
            size="175px"
          >
            <ProfilePhoto />
          </v-avatar>
        </v-col>

        <v-col>
          <v-row>
            <v-col>
              <p class="text-h4">
                {{ store.state.profile.name }}
              </p>
              <p class="text-h5">
                {{ currentJobTitle }}
              </p>
            </v-col>
            <v-col class="text-right">
              <router-link :to="{ name: 'ManagerAccount' }">
                <v-icon
                  class="fs-22 c-grey va-sub"
                  icon="edit"
                />
              </router-link>
              <v-icon
                v-if="false"
                class="fs-22 c-grey va-sub"
                icon="more_vert"
              />
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <v-row>
            <v-col>
              <p class="text-body-1 mb-2">
                <span class="disc">{{ store.state.profile.email }}</span>
                <span
                  v-if="store.state.profile.phone"
                  class="disc"
                  >{{ store.state.profile.phone }}</span
                >
              </p>
              <p class="text-body-1 mb-2">
                <span class="disc"
                  >{{ yearsInEceField }} {{ yearsInEceField === 1 ? 'year' : 'years' }} in the ECE
                  Field</span
                >
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useStore } from 'vuex';

import { newUtcDate } from '@/shared/services/date-helper';
import ProfilePhoto from '@/manager/components/profile/ProfilePhoto.vue';
const store = useStore();

const currentJobTitle = computed(() => {
  const employment = store.getters.currentEmployment();
  return (
    employment?.title ||
    `${employment?.business_role} at ${employment?.business_name}` ||
    'No current employment listed'
  );
});

const yearsInEceField = computed(() => {
  const employments = store.state.profile?.employments || [];
  const now = new Date();
  const MS_PER_MONTH = 1000 * 60 * 60 * 24 * 30.44;

  const totalMonths = employments.reduce((sum, employment) => {
    if (!employment?.start_date) return sum;
    const start = newUtcDate(employment.start_date);
    const end = employment.end_date ? newUtcDate(employment.end_date) : newUtcDate(now);
    const months = Math.max(0, (end - start) / MS_PER_MONTH);
    return sum + months;
  }, 0);

  return Math.floor(totalMonths / 12);
});
</script>

<style scoped>
.disc:not(:first-of-type) {
  margin-left: 5px;
  padding-left: 15px;
  position: relative;
}
.disc:not(:first-of-type):before {
  content: '•';
  left: 0;
  position: absolute;
}
</style>
